import React, { Component } from 'react';
import Drawer from '@material-ui/core/Drawer';
import "./SideBar.css"
import Hidden from '@material-ui/core/Hidden';
import SideBarContent from './SideBarContent';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Box } from '@material-ui/core';

class SideBar extends Component {

    render() {
        return (
            <Box boxShadow={3} className="full-height" >
                <div className="full-height">
                    <Hidden only={['md', 'lg', "xl"]}>
                        <SwipeableDrawer
                            anchor="left"
                            variant="temporary"
                            open={this.props.sideMenuOpened}
                            onClose={this.props.closeSideMenu}
                            onOpen={this.props.openSideMenu}
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}
                        >
                            <SideBarContent closeSideMenu={this.props.closeSideMenu} >
                                {this.props.children}
                            </SideBarContent>
                        </SwipeableDrawer>
                    </Hidden>
                    <Hidden only={['sm', 'xs']}>
                        <Drawer
                            PaperProps={{ style: { boxShadow: "5px 3px 10px rgb(0 0 0 / 40%)", borderRight: "unset" } }}
                            open
                            variant="permanent"
                        >
                            <SideBarContent permanent closeSideMenu={this.props.closeSideMenu}  >
                                {this.props.children}
                            </SideBarContent>
                        </Drawer>
                    </Hidden>
                </div>
            </Box >
        );
    }
}

export default (SideBar);
